/** Section heading of a Tauschbörse dialog — the `FormLabel component="legend"` above a FormControl. */
export const exchangeSectionLabelSx = {
  mb: 1.5,
  fontSize: "0.75rem",
  fontWeight: 700,
  letterSpacing: 0.5,
  textTransform: "uppercase",
  color: "text.primary",
  // The explicit colour above would otherwise outrank MUI's error state on the enclosing
  // FormControl, leaving the section heading black while its content is marked.
  "&.Mui-error": { color: "error.main" },
} as const;
